<template>
  <div class="input-item">
    <label>{{ label }}</label>
    <Input
      :value="value"
      @on-change="update"
      :placeholder="placeholder"
      size="large"
      v-if="type === 'text'"
      :name="name"
    />
    <DatePicker
      :value="value"
      @on-change="update"
      :placeholder="placeholder"
      style="width: 100%"
      size="large"
      :name="name"
      v-if="type === 'date'"
    />
    <Select
      v-if="type === 'select'"
      :value="value"
      @on-change="update"
      style="width:100%"
      size="large"
      :placeholder="placeholder"
      :name="name"
    >
      <Option v-for="item in items" :value="item.value" :key="item.value">{{ item.label }}</Option>
    </Select>
    <RadioGroup @on-change="update" v-if="type === 'radio'" style="width: 100%" :name="name" :value="value">
      <Radio v-for="item in items" :label="item.value" :key="item.value">{{ item.label }}</Radio>
    </RadioGroup>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: 'text',
    },
    items: {
      type: Array,
      default: () => [],
    },
    label: {
      type: String,
    },
    placeholder: {
      type: String,
    },
    name: {
      type: String,
    },
    value: {
      type: String,
    },
  },
  methods: {
    update(event) {
      this.$emit('input', typeof event === 'object' ? event.target.value : event);
    },
  },
};
</script>
<style lang="scss">
.input-item {
  margin-bottom: 10px;
}
</style>
